export default __webpack_public_path__ + "static/media/bitcoin.693f5ce3.jpeg";